import React from 'react';
import Player from '../Video/VideoPlayer';
import './styles.scss';

export default ({ url, id = '', image = '', enterTitle = ''}) => {
  return (
    <div className="single-video thumbnail-slider">
      <div className="container">
        <div className="row">
          <div className="col-12 col-xl-8 offset-xl-2">
            {enterTitle ? <h4>{enterTitle}</h4> : ""}
            <Player
              url={url}
              autoPlay={false}
              image={image}
              script="https://cdn.jwplayer.com/libraries/niqngNhI.js"
              id={`single_video_${id}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
